import { createStructuredSelector } from 'reselect';
import {
  apiBaseUrlSelector,
  tokenSelector,
  propertySelector,
  taxingUnitSelector,
  officeSelector,
  clientConfigSelector,
  currentYearSelector
} from '../../selectors/global';

export default createStructuredSelector({
  apiBaseUrl: apiBaseUrlSelector,
  currentYear: currentYearSelector,
  token: tokenSelector,
  property: propertySelector,
  taxingUnit: taxingUnitSelector,
  office: officeSelector,
  clientConfig: clientConfigSelector
});
